// extracted by mini-css-extract-plugin
export default {"iconContainer":"hy71VC","icon":"ShsbPg","iconImg":"V72yLJ","iconWithMaxWidth100":"tPe0Ij","grayScale":"XbwNmD"};